
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12335',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12335",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.467",
  "data-fetching-client": "static-1.9686",
  "foundations-components": "static-1.7976",
  "foundations-components-legacy": "static-1.1001",
  "foundations-theming": "static-1.4439",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8032",
  "hub-http-shared-msw-handlers": "static-1.10013",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11491",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6482",
  "marketplace-storefront-base": "static-1.12396",
  "quartz": "static-1.7056",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16690",
  "reactive-variable-buffer-atom": "static-1.2877",
  "reporting-testing-lib": "static-1.9578",
  "settings-ui-lib": "static-1.12539",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7175",
  "ui-addon-i18n": "static-1.11167",
  "ui-addon-react-router-dom": "static-1.9561",
  "unified-auth": "static-1.515",
  "unified-auth-core-lib": "static-1.797",
  "usage-tracker": "static-1.7364",
  "usage-tracker-core": "static-1.7214",
  "customer-data-property-utils": "static-1.8109",
  "hub-http": "static-1.6240",
  "integrations-lib": "static-1.16216",
  "marketplace-ui-common": "static-1.19796",
  "property-management-iframe": "static-1.13228",
  "quartz-config": "static-1.834",
  "quartz-core": "static-1.6275",
  "quartz-routing": "static-1.486",
  "quick-fetch": "static-1.3930",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4671",
  "ts-schema": "static-1.4093",
  "ui-universal-auth": "static-1.9001",
  "UIComponents": "static-3.8437",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3412",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3333",
  "quartz-webpack": "static-1.3280",
  "bend-plugin-quartz-routing": "static-1.134",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4245",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4887",
  "foundations-theming-specialty": "static-1.2155",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9443",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5358",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2003",
  "ui-fonts": "static-1.753",
  "ui-images": "static-2.1159",
  "bend-plugin-foundations-theming": "static-1.2922",
  "foundations-theming-base": "static-1.3424",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3143",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4346",
  "ai-components-ui-library": "static-1.9033",
  "ai-rendering-library": "static-1.10246",
  "chirp-fetch": "static-1.1906",
  "connections-embed-lib": "static-1.1025",
  "copilot-toolkit": "static-1.11186",
  "feedback-loader": "static-1.29332",
  "laboratory-lib": "static-3.7174",
  "marketplace-embed": "static-1.22153",
  "marketplace-ui-details": "static-1.9692",
  "marketplace-ui-reviews": "static-1.19752",
  "marketplace-ui-tracking": "static-1.13967",
  "sanitize-text": "static-1.8160",
  "ui-addon-video-player": "static-1.8721",
  "usage-tracker-multi": "static-1.5778",
  "usage-tracker-session-replay": "static-1.5050",
  "wootric-nps": "static-1.6993",
  "quartz-head": "static-1.721",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4670",
  "immer": "static-1.33",
  "immerable": "static-1.4172",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2500",
  "reporting-data": "static-1.67645",
  "cssUtils": "static-1.797",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11798",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10226",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10385",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7354",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18329",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4534",
  "foundations-components-test-utils": "static-1.5459",
  "quartz-i18n": "static-1.731",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.301",
  "microsoft-drive-integration-lib": "static-1.431",
  "slack-ui-library": "static-1.10411",
  "fsm": "static-1.3749",
  "customer-data-objects": "static-1.7688",
  "property-translator": "static-1.5418",
  "hs-locale-management": "static-1.94",
  "frontend-preferences-client": "static-1.7946",
  "hs-promise-utils": "static-1.5609",
  "hubspot-apollo-client": "static-1.4898",
  "integrations-error-boundary-lib": "static-1.13631",
  "integrations-tracking-lib": "static-1.5620",
  "native-integrations-shared-strings": "static-1.7800",
  "reselect": "static-2.16",
  "sanitize": "static-1.4495",
  "superstore": "static-1.4780",
  "ui-shepherd-react": "static-3.10187",
  "ai-settings-ui-library": "static-1.7915",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4665",
  "immutable-less": "static-1.4672",
  "marketplace-ui-client-types": "static-1.17203",
  "nav-meta": "static-1.29735",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10266",
  "ui-addon-upgrades": "static-9.18024",
  "inbound-db-properties-service-client": "static-1.3860",
  "property-management-common": "static-1.5516",
  "ui-addon-iframeable": "static-1.9077",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.731",
  "quartz-test": "static-1.731",
  "quartz-tracking": "static-1.435",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.81",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68428",
  "customer-data-objects-ui-components": "static-1.13047",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.71",
  "avatar-components": "static-1.2517",
  "customer-data-filters-ui": "static-1.39869",
  "customer-data-reference-ui-components": "static-1.13184",
  "embedded-academy-lib": "static-1.14409",
  "ExportDialog": "static-6.10404",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41363",
  "reporting-snowflake": "static-1.56263",
  "reporting-ui-components": "static-2.64916",
  "reporting-visualizations": "static-1.59721",
  "ui-addon-teams": "static-1.21582",
  "magpie-lib": "static-1.5563",
  "navigation-components": "static-1.18098",
  "magpie-types": "static-1.5023",
  "simple-logging-lib": "static-1.3069",
  "ai-studio-lib": "static-1.11677",
  "app-governance-lib": "static-1.1604",
  "developer-experience-shared-components": "static-1.10528",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8017",
  "ui-product-approvals": "static-1.28197",
  "ui-tool-access": "static-1.10166",
  "usage-based-billing-components-lib": "static-1.9000",
  "usage-tracker-anonymous": "static-1.5781",
  "usage-tracker-public": "static-1.7175",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3600",
  "persist-promise": "static-1.3717",
  "reference-resolvers": "static-1.8189",
  "ui-extensibility-client-types": "static-1.3943",
  "hubspot-apollo-cache": "static-1.357",
  "universal-page-editor-lib": "static-1.3032",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2840",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5091",
  "purchase-motions-components": "static-1.5941",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1560",
  "crm-component-utils": "static-1.39134",
  "crm-properties-common-lib": "static-1.5903",
  "customer-data-properties": "static-1.51626",
  "framework-data-schema-resolvers": "static-1.6903",
  "property-value-citations": "static-1.2240",
  "reference-resolvers-lite": "static-1.8113",
  "ui-business-units-lib": "static-1.9073",
  "navigation-messaging": "static-1.7425",
  "hubspotter-http-shared-msw-handlers": "static-1.10011",
  "cms-field-types": "static-1.4831",
  "content-icons-ui": "static-1.2232",
  "customer-data-ui-utilities": "static-1.9845",
  "events-data-lib": "static-1.241",
  "conversations-skeleton-state": "static-1.7266",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22304",
  "FormUrlGenerator": "static-2.4737",
  "framework-builder-read-service-client": "static-1.4019",
  "framework-data-schema-quick-fetch": "static-1.6808",
  "multi-account-reference-resolvers": "static-1.998",
  "onboarding-tours": "static-1.16650",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13744",
  "academy-common-lib": "static-1.13869",
  "content-assistance-lib": "static-1.7781",
  "dashboard-lib": "static-1.81614",
  "file-manager-components": "static-1.23680",
  "getting-started-shared-tasks": "static-1.18517",
  "hubspot-prosemirror": "static-1.18289",
  "hubspot-prosemirror-plugins": "static-1.18281",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19867",
  "share-with-third-party-component-lib": "static-1.8720",
  "ui-addon-draggable": "static-3.4782",
  "ui-asset-management-lib": "static-1.11062",
  "user-context": "static-1.5124",
  "growth-payments-core": "static-1.25441",
  "reporting-plugins": "static-1.10357",
  "reporting-reports": "static-1.67323",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.742",
  "nest": "static-1.246",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10645",
  "framework-listing-lib": "static-2.28768",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30764",
  "apps-service-types": "static-1.3898",
  "oauth-service-types": "static-1.4268",
  "ui-product-approvals-common": "static-1.92",
  "onboarding-scopes": "static-1.6480",
  "onboarding-tours-client": "static-1.4864",
  "platform-infra-nav-components": "static-1.7684",
  "subscription-experience-data-types": "static-1.14962",
  "crm-record-cards-service-types": "static-1.3611",
  "location-customization-utils-lib": "static-1.9326",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5944",
  "signup-constants": "static-1.18878",
  "signup-ui-url-generator": "static-2.8071",
  "trials-service-types": "static-1.3922",
  "card-properties-lib": "static-1.44249",
  "commerce-subscription-lib": "static-1.37182",
  "crm-actions": "static-1.6345",
  "crm-cards-sdk": "static-1.43651",
  "customer-data-properties-shared-msw-handlers": "static-1.9340",
  "customer-data-tracking": "static-1.6908",
  "hs-resources": "static-1.172",
  "pulse": "static-1.595",
  "calling-global-api": "static-1.64586",
  "calling-internal-common": "static-1.31321",
  "calling-lifecycle-internal": "static-1.65968",
  "calling-lifecycle-messages": "static-1.58262",
  "commerce-products-lib": "static-1.9646",
  "conditional-properties-service-client": "static-1.3811",
  "crm-links": "static-1.6313",
  "external-options-client-types": "static-1.4173",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4237",
  "meetings-icalendar-utils-lib": "static-1.650",
  "multi-currency-client-types": "static-1.3705",
  "object-builder-ui-client": "static-1.48815",
  "pipeline-validation-client-types": "static-1.3979",
  "smart-property-lib": "static-1.7185",
  "tiered-pricing": "static-1.1262",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11009",
  "crm-pipelines-api-client-types": "static-1.4153",
  "fdsr-migration-layer": "static-1.22",
  "react-dnd-compat": "static-1.4633",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.938",
  "growth-data-modal": "static-1.5458",
  "growth-onboarding-confetti": "static-1.3085",
  "growth-onboarding-next-action-utils": "static-1.1981",
  "onboarding-tours-utils": "static-1.716",
  "ui-shepherd-tracker": "static-1.7568",
  "academy-service-client": "static-1.3700",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39179",
  "FileManagerLib": "static-1.39320",
  "video-embed": "static-1.35832",
  "ui-coaching-tips": "static-1.28620",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11340",
  "video-data-lib": "static-1.34998",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8491",
  "payment-link-components": "static-1.23601",
  "ui-addon-emoji-picker": "static-1.9907",
  "EmailSignatureEditor": "static-1.24416",
  "viral-links-lib": "static-1.7085",
  "data-token-picker": "static-1.16441",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.245",
  "timezone-utils": "static-2.5263",
  "seat-types-lib": "static-1.58",
  "getting-started-shared-tasks-store": "static-1.17635",
  "ui-addon-opt": "static-4.8384",
  "campaign-roi-lib": "static-1.9185",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7344",
  "customer-data-views-management": "static-1.25504",
  "framework-data-table": "static-2.11960",
  "marketing-platform-lib": "static-1.6876",
  "nudge-client-utils": "static-1.2627",
  "nudge-custom-ui-functions": "static-1.1054",
  "app-users-service-client": "static-1.5616",
  "app-users-service-types": "static-1.5024",
  "mini-checkout-client": "static-1.26855",
  "onboarding-utils": "static-1.5372",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28605",
  "edison-service-client-types": "static-1.407",
  "crm_data": "static-4.92032",
  "customer-data-sidebar": "static-2.46077",
  "enrichment-properties-lib": "static-1.16303",
  "ui-addon-draggable-compat": "static-2.4275",
  "commerce-billing-lib": "static-1.19144",
  "commerce-shared-components-lib": "static-1.18596",
  "commerce-tools-ui-lib": "static-1.10433",
  "crm-fe-perf": "static-1.22922",
  "bend-plugin-pulse": "static-1.98",
  "directed-graph": "static-1.954",
  "event-emitter": "static-1.966",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31328",
  "shared-worker-versioning": "static-1.11055",
  "calling-usage-tracker": "static-1.6560",
  "voice-sms-access-library": "static-1.1063",
  "commerce-permissions": "static-1.788",
  "products-iframe-lib": "static-1.7995",
  "products-ui-components-shared-msw-handlers": "static-1.10395",
  "data-agent-kit": "static-1.225",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10096",
  "policy-lib": "static-1.6796",
  "react-tinymce": "static-1.55302",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10159",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54428",
  "tinymce-plugins": "static-1.57542",
  "tinymce-themes": "static-1.56398",
  "onboarding-data-sync-lib": "static-1.1987",
  "growth-onboarding-next-action-components": "static-1.2009",
  "user-context-client": "static-1.4631",
  "audio-components": "static-1.5944",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36831",
  "urlinator": "static-1.4555",
  "video-components": "static-1.13343",
  "outpost": "static-1.4199",
  "growth-onboarding-feedback-components": "static-1.6599",
  "content-media-composition-data-lib": "static-1.12385",
  "content-media-compositions": "static-2.16392",
  "media-bridge-lib": "static-1.18960",
  "commerce-tours-lib": "static-1.6139",
  "growth-onboarding-reliability": "static-1.5101",
  "sales-checkout-service-client": "static-1.3660",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21710",
  "sales-email-signature-service-client": "static-1.3862",
  "ts-utils-lib": "static-1.191",
  "breeze-engine-lib": "static-1.719",
  "crm-export-dialog": "static-1.6309",
  "crm-index-associations-lib": "static-1.6459",
  "crm-view-components": "static-1.330",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2384",
  "nudge-renderer-utils": "static-1.2703",
  "whisper-core-api": "static-1.6683",
  "InboxConnectUtils": "static-4.14872",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5599",
  "settings-content-modals": "static-1.46145",
  "crm_universal": "static-1.22041",
  "customer-data-email": "static-1.18068",
  "card-payment-highlight-lib": "static-1.37239",
  "card-subscription-highlight-lib": "static-1.39605",
  "commerce-contract-lib": "static-1.12147",
  "invoices-highlight-card-lib": "static-1.54798",
  "orders-highlight-card-lib": "static-1.21529",
  "products-highlight-card-lib": "static-1.17929",
  "quotes-highlight-card-lib": "static-1.72125",
  "crm-source-interpretation-lib": "static-1.5362",
  "utility-belt": "static-1.2553",
  "payments-enrollment-embed-lib": "static-1.22961",
  "stripe-embedded-components": "static-1.7540",
  "customer-data-rte": "static-1.33054",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5767",
  "payments-post-enroll-local-storage-lib": "static-1.5127",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38215",
  "calling-orchestration-schema": "static-1.35840",
  "sales-views-client-types": "static-1.4278",
  "hub-http-contrib": "static-1.3061",
  "interframe": "static-3.4778",
  "tinymce-data": "static-1.40513",
  "ui-addon-sales-email": "static-1.5229",
  "layout-dnd-components": "static-1.12481",
  "layout-dnd-utils": "static-1.11456",
  "ui-brand-identity-lib": "static-1.15366",
  "NamespacedHubStyle": "static-2.9072",
  "meetings-connect-utils-lib": "static-1.7624",
  "social-insights-client-types": "static-1.22180",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4160",
  "checkout-sdk": "static-3.23698",
  "checkout-service-types": "static-1.3835",
  "company-details-components": "static-1.6214",
  "payment-method-components": "static-1.6923",
  "pricing-pages-ui-components": "static-1.14109",
  "quote-checkout-service-types": "static-1.3486",
  "upgrade-catalog-service-types": "static-1.3539",
  "access-control-lib": "static-1.10454",
  "EmailComponents": "static-1.54809",
  "EmailData": "static-1.53486",
  "redux-less": "static-2.9502",
  "sequences-lib": "static-1.8075",
  "ui-gdpr-components": "static-1.10369",
  "products-ui-components": "static-1.40164",
  "accounting-integrations-ui-components": "static-1.7096",
  "invoices-ui-lib": "static-1.54814",
  "commerce-products-api": "static-1.2325",
  "invoices-iframe-lib": "static-1.56872",
  "quotes-modal-lib": "static-1.102803",
  "quotes-ui-lib": "static-1.80846",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28326",
  "ContentData": "static-1.68503",
  "layout-data-lib": "static-1.9781",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3958",
  "billing-payments-client-types": "static-1.4008",
  "react-performance-metrics-lib": "static-1.574",
  "account-and-billing-fintech-outages": "static-3.18616",
  "pricing-pages-api": "static-1.13974",
  "ContentComponents": "static-2.71384",
  "marketing-contacts-lib": "static-1.10114",
  "marketing-email-service-types": "static-1.1920",
  "messaging-editing-lib": "static-1.46338",
  "messaging-usage-based-billing-components-lib": "static-1.1200",
  "automation-ui-source-apps": "static-1.18952",
  "automation-ui-types": "static-1.19870",
  "messaging-types-lib": "static-1.46075",
  "onboarding-settings-client": "static-1.4523",
  "sequences-client-types-lib": "static-1.7932",
  "commerce-tax-lib": "static-1.545",
  "price-books-api": "static-1.814",
  "price-books-components": "static-1.872",
  "property-description-translator": "static-1.3862",
  "ramp-editor": "static-1.196",
  "commerce-analytics-service-client": "static-1.3648",
  "totals-ui-components": "static-1.23659",
  "SalesContentIndexUI": "static-3.9279",
  "advanced-menus-core": "static-1.15158",
  "advanced-menus-lib": "static-1.12096",
  "ui-memberships-settings-lib": "static-1.34106",
  "segments-query-core": "static-1.1437",
  "demographics-service-types": "static-1.1671",
  "eligibility-engine-service-types": "static-1.3203",
  "automation-ui-ubb": "static-1.5786",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7357",
  "data-token-views": "static-1.16422",
  "forms-utils-lib": "static-1.12622",
  "payments-embed-points-lib": "static-1.13077",
  "simple-menus-core": "static-1.15157",
  "simple-menus-lib": "static-1.16674",
  "videoconference-integration-components": "static-1.6848",
  "marketing-contacts-client": "static-1.7535",
  "automation-applications-service-types": "static-1.3527",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77180",
  "short-messages-app-service-client": "static-1.3987",
  "web-interactives-components": "static-1.13793",
  "web-interactives-data": "static-1.13794",
  "messaging-shared-utils-lib": "static-1.649",
  "messaging-user-info-utils-lib": "static-1.819",
  "email-portal-health-service-types": "static-1.997",
  "line-items-api": "static-1.725",
  "commerce-totals-service-types": "static-1.3833",
  "FireAlarmUi": "static-1.4526",
  "sales-templates-service-types-lib": "static-1.4184",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21806",
  "automation-ui-usage-tracking": "static-1.21269",
  "data-studio-ubb": "static-1.2788",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27081",
  "collaboration-sidebar": "static-1.57892",
  "content-management-data-lib": "static-1.5414",
  "copilot-plugins": "static-1.11159",
  "cta-picker": "static-1.36461",
  "customer-agent-discovery-components-lib": "static-1.3144",
  "editor-components": "static-1.13255",
  "editor-iframe-lib": "static-1.8429",
  "error-messaging-js": "static-1.5211",
  "FormsCommonComponents": "static-1.85912",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10664",
  "SharedLegalStrings": "static-1.1766",
  "smart-content-core": "static-1.42503",
  "smart-content-lib": "static-1.43156",
  "social-composer-lib": "static-1.59244",
  "structured-content-lib": "static-1.25250",
  "theme-previewer-lib": "static-1.53306",
  "tinymce-copilot": "static-1.16496",
  "xray-recommendation-lib": "static-1.7934",
  "automation-ui-routing": "static-1.21227",
  "sql-reporting-client-types": "static-1.5653",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42244",
  "campaigns-utils-lib": "static-1.3200",
  "reporting-enablement": "static-1.22999",
  "chatspot-widget-iframe": "static-1.21403",
  "collaboration-sidebar-common": "static-1.2689",
  "forms-ai-lib": "static-1.4348",
  "codemirror-dlb": "static-1.58739",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6450",
  "report-customization-components": "static-1.13229",
  "data-quality-ui-library": "static-1.13089",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.378",
  "reporting-insights-lib": "static-1.1811"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12335",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.467",
  "data-fetching-client": "/data-fetching-client/static-1.9686",
  "foundations-components": "/foundations-components/static-1.7976",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1001",
  "foundations-theming": "/foundations-theming/static-1.4439",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8032",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10013",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11491",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6482",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12396",
  "quartz": "/quartz/static-1.7056",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16690",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2877",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9578",
  "settings-ui-lib": "/settings-ui-lib/static-1.12539",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7175",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11167",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9561",
  "unified-auth": "/unified-auth/static-1.515",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.797",
  "usage-tracker": "/usage-tracker/static-1.7364",
  "usage-tracker-core": "/usage-tracker-core/static-1.7214",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8109",
  "hub-http": "/hub-http/static-1.6240",
  "integrations-lib": "/integrations-lib/static-1.16216",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19796",
  "property-management-iframe": "/property-management-iframe/static-1.13228",
  "quartz-config": "/quartz-config/static-1.834",
  "quartz-core": "/quartz-core/static-1.6275",
  "quartz-routing": "/quartz-routing/static-1.486",
  "quick-fetch": "/quick-fetch/static-1.3930",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4671",
  "ts-schema": "/ts-schema/static-1.4093",
  "ui-universal-auth": "/ui-universal-auth/static-1.9001",
  "UIComponents": "/UIComponents/static-3.8437",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3412",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3333",
  "quartz-webpack": "/quartz-webpack/static-1.3280",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.134",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4245",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4887",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2155",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9443",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5358",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2003",
  "ui-fonts": "/ui-fonts/static-1.753",
  "ui-images": "/ui-images/static-2.1159",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2922",
  "foundations-theming-base": "/foundations-theming-base/static-1.3424",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3143",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4346",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9033",
  "ai-rendering-library": "/ai-rendering-library/static-1.10246",
  "chirp-fetch": "/chirp-fetch/static-1.1906",
  "connections-embed-lib": "/connections-embed-lib/static-1.1025",
  "copilot-toolkit": "/copilot-toolkit/static-1.11186",
  "feedback-loader": "/feedback-loader/static-1.29332",
  "laboratory-lib": "/laboratory-lib/static-3.7174",
  "marketplace-embed": "/marketplace-embed/static-1.22153",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9692",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19752",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13967",
  "sanitize-text": "/sanitize-text/static-1.8160",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8721",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5778",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5050",
  "wootric-nps": "/wootric-nps/static-1.6993",
  "quartz-head": "/quartz-head/static-1.721",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4670",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4172",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "reporting-data": "/reporting-data/static-1.67645",
  "cssUtils": "/cssUtils/static-1.797",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11798",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10226",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10385",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7354",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18329",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4534",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5459",
  "quartz-i18n": "/quartz-i18n/static-1.731",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.301",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.431",
  "slack-ui-library": "/slack-ui-library/static-1.10411",
  "fsm": "/fsm/static-1.3749",
  "customer-data-objects": "/customer-data-objects/static-1.7688",
  "property-translator": "/property-translator/static-1.5418",
  "hs-locale-management": "/hs-locale-management/static-1.94",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7946",
  "hs-promise-utils": "/hs-promise-utils/static-1.5609",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4898",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13631",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5620",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7800",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4495",
  "superstore": "/superstore/static-1.4780",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10187",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7915",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4665",
  "immutable-less": "/immutable-less/static-1.4672",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17203",
  "nav-meta": "/nav-meta/static-1.29735",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10266",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18024",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3860",
  "property-management-common": "/property-management-common/static-1.5516",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9077",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.731",
  "quartz-test": "/quartz-test/static-1.731",
  "quartz-tracking": "/quartz-tracking/static-1.435",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.81",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68428",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13047",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.71",
  "avatar-components": "/avatar-components/static-1.2517",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39869",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13184",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14409",
  "ExportDialog": "/ExportDialog/static-6.10404",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41363",
  "reporting-snowflake": "/reporting-snowflake/static-1.56263",
  "reporting-ui-components": "/reporting-ui-components/static-2.64916",
  "reporting-visualizations": "/reporting-visualizations/static-1.59721",
  "ui-addon-teams": "/ui-addon-teams/static-1.21582",
  "magpie-lib": "/magpie-lib/static-1.5563",
  "navigation-components": "/navigation-components/static-1.18098",
  "magpie-types": "/magpie-types/static-1.5023",
  "simple-logging-lib": "/simple-logging-lib/static-1.3069",
  "ai-studio-lib": "/ai-studio-lib/static-1.11677",
  "app-governance-lib": "/app-governance-lib/static-1.1604",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10528",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8017",
  "ui-product-approvals": "/ui-product-approvals/static-1.28197",
  "ui-tool-access": "/ui-tool-access/static-1.10166",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9000",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5781",
  "usage-tracker-public": "/usage-tracker-public/static-1.7175",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3600",
  "persist-promise": "/persist-promise/static-1.3717",
  "reference-resolvers": "/reference-resolvers/static-1.8189",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3943",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.357",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3032",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2840",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5091",
  "purchase-motions-components": "/purchase-motions-components/static-1.5941",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1560",
  "crm-component-utils": "/crm-component-utils/static-1.39134",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5903",
  "customer-data-properties": "/customer-data-properties/static-1.51626",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6903",
  "property-value-citations": "/property-value-citations/static-1.2240",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8113",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9073",
  "navigation-messaging": "/navigation-messaging/static-1.7425",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10011",
  "cms-field-types": "/cms-field-types/static-1.4831",
  "content-icons-ui": "/content-icons-ui/static-1.2232",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9845",
  "events-data-lib": "/events-data-lib/static-1.241",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7266",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22304",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4737",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4019",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6808",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.998",
  "onboarding-tours": "/onboarding-tours/static-1.16650",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13744",
  "academy-common-lib": "/academy-common-lib/static-1.13869",
  "content-assistance-lib": "/content-assistance-lib/static-1.7781",
  "dashboard-lib": "/dashboard-lib/static-1.81614",
  "file-manager-components": "/file-manager-components/static-1.23680",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18517",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18289",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18281",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19867",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8720",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4782",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11062",
  "user-context": "/user-context/static-1.5124",
  "growth-payments-core": "/growth-payments-core/static-1.25441",
  "reporting-plugins": "/reporting-plugins/static-1.10357",
  "reporting-reports": "/reporting-reports/static-1.67323",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.742",
  "nest": "/nest/static-1.246",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10645",
  "framework-listing-lib": "/framework-listing-lib/static-2.28768",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30764",
  "apps-service-types": "/apps-service-types/static-1.3898",
  "oauth-service-types": "/oauth-service-types/static-1.4268",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.92",
  "onboarding-scopes": "/onboarding-scopes/static-1.6480",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4864",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7684",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14962",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3611",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9326",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5944",
  "signup-constants": "/signup-constants/static-1.18878",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8071",
  "trials-service-types": "/trials-service-types/static-1.3922",
  "card-properties-lib": "/card-properties-lib/static-1.44249",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37182",
  "crm-actions": "/crm-actions/static-1.6345",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43651",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9340",
  "customer-data-tracking": "/customer-data-tracking/static-1.6908",
  "hs-resources": "/hs-resources/static-1.172",
  "pulse": "/pulse/static-1.595",
  "calling-global-api": "/calling-global-api/static-1.64586",
  "calling-internal-common": "/calling-internal-common/static-1.31321",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65968",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58262",
  "commerce-products-lib": "/commerce-products-lib/static-1.9646",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3811",
  "crm-links": "/crm-links/static-1.6313",
  "external-options-client-types": "/external-options-client-types/static-1.4173",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4237",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.650",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3705",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48815",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3979",
  "smart-property-lib": "/smart-property-lib/static-1.7185",
  "tiered-pricing": "/tiered-pricing/static-1.1262",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11009",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4153",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.22",
  "react-dnd-compat": "/react-dnd-compat/static-1.4633",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.938",
  "growth-data-modal": "/growth-data-modal/static-1.5458",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3085",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1981",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.716",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7568",
  "academy-service-client": "/academy-service-client/static-1.3700",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39179",
  "FileManagerLib": "/FileManagerLib/static-1.39320",
  "video-embed": "/video-embed/static-1.35832",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28620",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11340",
  "video-data-lib": "/video-data-lib/static-1.34998",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8491",
  "payment-link-components": "/payment-link-components/static-1.23601",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9907",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24416",
  "viral-links-lib": "/viral-links-lib/static-1.7085",
  "data-token-picker": "/data-token-picker/static-1.16441",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.245",
  "timezone-utils": "/timezone-utils/static-2.5263",
  "seat-types-lib": "/seat-types-lib/static-1.58",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17635",
  "ui-addon-opt": "/ui-addon-opt/static-4.8384",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9185",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7344",
  "customer-data-views-management": "/customer-data-views-management/static-1.25504",
  "framework-data-table": "/framework-data-table/static-2.11960",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6876",
  "nudge-client-utils": "/nudge-client-utils/static-1.2627",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1054",
  "app-users-service-client": "/app-users-service-client/static-1.5616",
  "app-users-service-types": "/app-users-service-types/static-1.5024",
  "mini-checkout-client": "/mini-checkout-client/static-1.26855",
  "onboarding-utils": "/onboarding-utils/static-1.5372",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28605",
  "edison-service-client-types": "/edison-service-client-types/static-1.407",
  "crm_data": "/crm_data/static-4.92032",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46077",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16303",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4275",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19144",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18596",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10433",
  "crm-fe-perf": "/crm-fe-perf/static-1.22922",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.98",
  "directed-graph": "/directed-graph/static-1.954",
  "event-emitter": "/event-emitter/static-1.966",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31328",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11055",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6560",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1063",
  "commerce-permissions": "/commerce-permissions/static-1.788",
  "products-iframe-lib": "/products-iframe-lib/static-1.7995",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10395",
  "data-agent-kit": "/data-agent-kit/static-1.225",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10096",
  "policy-lib": "/policy-lib/static-1.6796",
  "react-tinymce": "/react-tinymce/static-1.55302",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10159",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54428",
  "tinymce-plugins": "/tinymce-plugins/static-1.57542",
  "tinymce-themes": "/tinymce-themes/static-1.56398",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1987",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2009",
  "user-context-client": "/user-context-client/static-1.4631",
  "audio-components": "/audio-components/static-1.5944",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36831",
  "urlinator": "/urlinator/static-1.4555",
  "video-components": "/video-components/static-1.13343",
  "outpost": "/outpost/static-1.4199",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6599",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12385",
  "content-media-compositions": "/content-media-compositions/static-2.16392",
  "media-bridge-lib": "/media-bridge-lib/static-1.18960",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6139",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5101",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3660",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21710",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3862",
  "ts-utils-lib": "/ts-utils-lib/static-1.191",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.719",
  "crm-export-dialog": "/crm-export-dialog/static-1.6309",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6459",
  "crm-view-components": "/crm-view-components/static-1.330",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2384",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2703",
  "whisper-core-api": "/whisper-core-api/static-1.6683",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14872",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5599",
  "settings-content-modals": "/settings-content-modals/static-1.46145",
  "crm_universal": "/crm_universal/static-1.22041",
  "customer-data-email": "/customer-data-email/static-1.18068",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37239",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39605",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12147",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54798",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21529",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17929",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72125",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5362",
  "utility-belt": "/utility-belt/static-1.2553",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22961",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7540",
  "customer-data-rte": "/customer-data-rte/static-1.33054",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5767",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5127",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38215",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35840",
  "sales-views-client-types": "/sales-views-client-types/static-1.4278",
  "hub-http-contrib": "/hub-http-contrib/static-1.3061",
  "interframe": "/interframe/static-3.4778",
  "tinymce-data": "/tinymce-data/static-1.40513",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5229",
  "layout-dnd-components": "/layout-dnd-components/static-1.12481",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11456",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15366",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9072",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7624",
  "social-insights-client-types": "/social-insights-client-types/static-1.22180",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4160",
  "checkout-sdk": "/checkout-sdk/static-3.23698",
  "checkout-service-types": "/checkout-service-types/static-1.3835",
  "company-details-components": "/company-details-components/static-1.6214",
  "payment-method-components": "/payment-method-components/static-1.6923",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14109",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3486",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3539",
  "access-control-lib": "/access-control-lib/static-1.10454",
  "EmailComponents": "/EmailComponents/static-1.54809",
  "EmailData": "/EmailData/static-1.53486",
  "redux-less": "/redux-less/static-2.9502",
  "sequences-lib": "/sequences-lib/static-1.8075",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10369",
  "products-ui-components": "/products-ui-components/static-1.40164",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7096",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54814",
  "commerce-products-api": "/commerce-products-api/static-1.2325",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56872",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102803",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80846",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28326",
  "ContentData": "/ContentData/static-1.68503",
  "layout-data-lib": "/layout-data-lib/static-1.9781",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3958",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4008",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.574",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18616",
  "pricing-pages-api": "/pricing-pages-api/static-1.13974",
  "ContentComponents": "/ContentComponents/static-2.71384",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10114",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1920",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46338",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1200",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18952",
  "automation-ui-types": "/automation-ui-types/static-1.19870",
  "messaging-types-lib": "/messaging-types-lib/static-1.46075",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4523",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7932",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.545",
  "price-books-api": "/price-books-api/static-1.814",
  "price-books-components": "/price-books-components/static-1.872",
  "property-description-translator": "/property-description-translator/static-1.3862",
  "ramp-editor": "/ramp-editor/static-1.196",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3648",
  "totals-ui-components": "/totals-ui-components/static-1.23659",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9279",
  "advanced-menus-core": "/advanced-menus-core/static-1.15158",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12096",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34106",
  "segments-query-core": "/segments-query-core/static-1.1437",
  "demographics-service-types": "/demographics-service-types/static-1.1671",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3203",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5786",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7357",
  "data-token-views": "/data-token-views/static-1.16422",
  "forms-utils-lib": "/forms-utils-lib/static-1.12622",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13077",
  "simple-menus-core": "/simple-menus-core/static-1.15157",
  "simple-menus-lib": "/simple-menus-lib/static-1.16674",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6848",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7535",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3527",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77180",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3987",
  "web-interactives-components": "/web-interactives-components/static-1.13793",
  "web-interactives-data": "/web-interactives-data/static-1.13794",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.649",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.819",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.997",
  "line-items-api": "/line-items-api/static-1.725",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3833",
  "FireAlarmUi": "/FireAlarmUi/static-1.4526",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4184",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21806",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21269",
  "data-studio-ubb": "/data-studio-ubb/static-1.2788",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27081",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57892",
  "content-management-data-lib": "/content-management-data-lib/static-1.5414",
  "copilot-plugins": "/copilot-plugins/static-1.11159",
  "cta-picker": "/cta-picker/static-1.36461",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3144",
  "editor-components": "/editor-components/static-1.13255",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8429",
  "error-messaging-js": "/error-messaging-js/static-1.5211",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85912",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10664",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1766",
  "smart-content-core": "/smart-content-core/static-1.42503",
  "smart-content-lib": "/smart-content-lib/static-1.43156",
  "social-composer-lib": "/social-composer-lib/static-1.59244",
  "structured-content-lib": "/structured-content-lib/static-1.25250",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53306",
  "tinymce-copilot": "/tinymce-copilot/static-1.16496",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7934",
  "automation-ui-routing": "/automation-ui-routing/static-1.21227",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5653",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42244",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3200",
  "reporting-enablement": "/reporting-enablement/static-1.22999",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21403",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2689",
  "forms-ai-lib": "/forms-ai-lib/static-1.4348",
  "codemirror-dlb": "/codemirror-dlb/static-1.58739",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6450",
  "report-customization-components": "/report-customization-components/static-1.13229",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13089",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.378",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1811"
}
};
